/* eslint-disable */
const getters = {
  getBundle(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
